export async function fetchProfile() {
  const res = await fetch('/api/user/profile', { credentials: 'include' });
  if (!res.ok) {
    if (res.status === 401) {
      const errorData = await res.json().catch(() => ({}));
      if (errorData.error === 'token_expired') {
        throw new Error('TOKEN_EXPIRED');
      } else {
        // Any 401 that isn't specifically token_expired is an auth failure
        throw new Error('UNAUTHENTICATED');
      }
    }
    throw new Error('Failed to fetch profile');
  }
  return res.json();
}

export async function logout() {
  const res = await fetch('/auth/logout', { method: 'POST', credentials: 'include' });
  if (!res.ok) {
    throw new Error('Failed to log out');
  }
}

export async function fetchSetlists() {
  const res = await fetch('/api/setlists/latest', { credentials: 'include' });
  if (!res.ok) {
    if (res.status === 401) {
      throw new Error('UNAUTHENTICATED');
    }
    throw new Error('Failed to fetch setlists');
  }
  return res.json();
}
